import "aos/dist/aos.css";
import { useState } from "react";
import { ExternalLink } from "lucide-react";

const HeroSection = () => {

  return (
    <>
      <section className="px-4 sm:px-6 md:px-[5%] py-12 bg-white">
        <div className="max-w-7xl mx-auto flex flex-col items-center gap-12">
          {/* Heading & Description */}
          <div className="text-center max-w-3xl">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-800 mb-4">
              Contact <span className="text-[#0d6b68]">EduLynks</span>
            </h2>
            <p className="text-gray-600 text-base md:text-lg">
              Have questions or want to get in touch? Reach out to us and our
              team will assist you with any queries about EduLynks Dashboard and
              services.
            </p>
          </div>

          {/* Social Media Icons */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
            {[
              { icon: "fab fa-facebook-f", link: "#" },
              { icon: "fab fa-linkedin-in", link: "#" },
              { icon: "fab fa-twitter", link: "#" },
              { icon: "fab fa-youtube", link: "#" },
            ].map((item, idx) => (
              <a
                key={idx}
                href={item.link}
                className="text-white bg-[#0d6b68] hover:bg-[#1c8c89] w-20 h-20 sm:w-24 sm:h-24 flex items-center justify-center rounded-full text-3xl sm:text-5xl transition-transform transform hover:scale-110"
              >
                <i className={item.icon}></i>
              </a>
            ))}
          </div>

          {/* Contact Info */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 w-full text-gray-800">
            {/* Address - Now Clickable */}
            <a
              href="https://www.google.com/maps?q=#6,+2nd+Floor,+Maruthi+Complex,+New+BEL+Road,+Bangalore,+Karnataka,+560054"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-4 border-2 border-[#0d6b68] rounded-2xl p-4 transition hover:bg-[#0d6b68]"
            >
              <i className="fas fa-map-marker-alt text-[#0d6b68] text-2xl transition group-hover:text-white"></i>
              <p className="text-left transition group-hover:text-white">
                #6, 2nd Floor, Maruthi Complex, New BEL Road, Bangalore,
                Karnataka, 560054
              </p>
            </a>

            {/* Phone */}
            <a
              href="tel:+917994670962"
              className="group flex items-center gap-4 border-2 border-[#0d6b68] rounded-2xl p-4 transition hover:bg-[#0d6b68]"
            >
              <i className="fas fa-phone-alt text-[#0d6b68] text-2xl transition group-hover:text-white"></i>
              <p className="text-left transition group-hover:text-white">
                +91 79946 70962
              </p>
            </a>

            {/* Email */}
            <a
              href="mailto:contact@edulynks.in"
              className="group flex items-center gap-4 border-2 border-[#0d6b68] rounded-2xl p-4 transition hover:bg-[#0d6b68]"
            >
              <i className="fas fa-envelope text-[#0d6b68] text-2xl transition group-hover:text-white"></i>
              <p className="text-left transition group-hover:text-white">
                contact@edulynks.in
              </p>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
